import Link from "next/link";
import React, { FC } from "react";
import { ReactNode } from "react";

interface Props {
  children?: ReactNode;
  readMore?: boolean;
  readMoreLink?: string;
}

const SectionTitle: FC<Props> = ({ children, readMore, readMoreLink }) => {
  return (
    <section tw="grid grid-flow-col items-center justify-between">
      <h3 tw="font-base text-sm leading-none tracking-[.08px]">{children}</h3>
      {readMore && readMoreLink && (
        <Link href={readMoreLink}>
          <a tw="text-2xs text-theme cursor-pointer">もっと見る</a>
        </Link>
      )}
    </section>
  );
};

export default SectionTitle;
